import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import M from 'materialize-css/dist/js/materialize';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import ConfirmationList from './ConfirmationList';
import { startLoading, endLoading } from '../../../actions/loadingAction';
import ConfirmModal from '../../../components/UI/ConfirmModal';
import ButtonUI from '../../../components/UI/ButtonUI';
import { configs, isNullOrEmpty, translate } from '../../../utils/util';
import { ENUMS, VISIONS } from '../../../utils/constants';
import { getVision } from '../../../services/auth';

const ConfirmationReceipt = (props) => {
    const [configState, setConfig] = useState({});
    const [listTransmissions, setListTransmissions] = useState([]);

    useEffect(() => {
        setConfig(configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items));
        getTransmission();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        let transmissions = [];
        Object.assign(transmissions, props.transmissions);
        setListTransmissions(transmissions);
        // eslint-disable-next-line
    }, [props.transmissions]);

    const getTransmission = () => {
        if ((!isNullOrEmpty(props.physicalConfirmation?.mvmNumber) || !isNullOrEmpty(props.physicalConfirmation?.journey) || props.receiptIds.length > 0)) {
            props.getTransmissions({
                mvm: props.physicalConfirmation.mvmNumber,
                journey: props.physicalConfirmation.journey,
                shed: !props.filter.truckKanban && !isNullOrEmpty(props.user?.shed) ? props.sheds.find((i) => i.id === props.user.shed).code : "",
                truckKanban: props.filter.truckKanban,
                receiptIds: props.receiptIds,
                printed: false
            });
        }
    }

    const deleteAll = () => {
        var ids = [];

        if (getVision() === (VISIONS.Faasa || VISIONS.FaasaCKD) && props.receiptIds.length > 0) {
            ids = props.receiptIds;
        } else {
            props.receipts.forEach(element => {
                ids.push(element.id);
            });
        }
        props.removeAllConfirmation(
            ids,
            getTransmission);
    }

    const openModalReceived = () => {
        const modalReceived = M.Modal.init(document.getElementById('confirmDeleteReceipt'));
        modalReceived.open();
    }

    return (
        <div>
            <div className="container-fluid h-65" />
            <div className="container">
                {
                    listTransmissions && listTransmissions.filter((i) => (!i.success)).length > 0 && (
                        <div className="col s12 center" style={{ marginTop: '8px' }}>
                            <ButtonUI full="true" onClick={openModalReceived} text={translate('clear', 'physical-confirmation')} icon="delete" />
                        </div>)
                }
            </div>
            <ConfirmationList
                data={listTransmissions}
                getTransmission={getTransmission}
                config={configState} />
            <ConfirmModal
                id="confirmDeleteReceipt"
                data={{ title: translate('clear', 'physical-confirmation'), message: translate('delete-alert', 'physical-confirmation') }}
                onConfirm={() => { deleteAll(); }}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div >
    );
}

const mapStateToProps = (state) => {
    return {
        transmissions: state.physicalConfirmationReducer.transmissions,
        receipts: state.physicalConfirmationReducer.receipts,
        user: state.userReducer.user,
        sheds: state.configReducer.sheds,
        config: state.configReducer.config,
        physicalConfirmation: state.physicalConfirmationReducer.physicalConfirmation,
        filter: state.physicalConfirmationReducer.filter,
        receiptIds: state.physicalConfirmationReducer.receiptIds,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        removeAllConfirmation: (id, mvmNumber, callback) => {
            dispatch(PhysicalConfirmationService.removeAllConfirmation(id, mvmNumber, callback));
        },
        showLoading: () => {
            dispatch(startLoading());
        },
        hideLoading: () => {
            dispatch(endLoading());
        },
        getTransmissions: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getTransmissions(filter, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ConfirmationReceipt));
